import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\UnTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/UnTrashModelNotificationController.php
* @route '/api/un-trash'
*/
const UnTrashModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnTrashModelNotificationController.url(options),
    method: 'post',
})

UnTrashModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/un-trash',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\UnTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/UnTrashModelNotificationController.php
* @route '/api/un-trash'
*/
UnTrashModelNotificationController.url = (options?: RouteQueryOptions) => {
    return UnTrashModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\UnTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/UnTrashModelNotificationController.php
* @route '/api/un-trash'
*/
UnTrashModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnTrashModelNotificationController.url(options),
    method: 'post',
})

export default UnTrashModelNotificationController